<template>
    <section :class="sectionClasses">

        <div class="box" :style="openType === 'modal' ? 'padding: 0 20px' : ''">

            <!-- HEADER SOLO SE NON È MODAL -->
            <div v-if="openType !== 'modal'" class="table__header">
                <h1>{{ title }}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'libraryList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>

            <!-- FORM -->
            <div class="table__form">

                <!-- NAME -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Nome</strong></div>
                    <input type="text" v-model="library.library" />
                </div>

                <!-- SCRIPT TYPE -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Categoria cookie</strong></div>
                    <select v-model="library.type_id">
                        <option
                            v-for="scriptType in scriptTypes"
                            :key="scriptType.id"
                            :value="scriptType.id"
                        >
                            {{ scriptType.translations[0].translation }}
                        </option>
                    </select>
                </div>

                <!-- VISIBLE NAME -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Nome Visible</strong></div>
                    <input type="text" v-model="library.name" />
                </div>

                <!-- SUPPLIER -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Fornitore</strong></div>
                    <input type="text" v-model="library.supplier" />
                </div>

                <!-- EXPIRY MULTILINGUA -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Scadenza</strong></div>

                    <div class="translations">
                        <!-- LINGUE -->
                        <ul class="change-languages">
                            <li
                                v-for="language in languages"
                                :key="language.id"
                                @click="languageSelect(language.slug)"
                                :class="{ selected: languageSelected === language.slug }"
                            >
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>

                        <!-- CAMPI MULTILINGUA -->
                        <div
                            v-for="language in languages"
                            :key="language.id"
                            v-if="languageSelected === language.slug &&
                                   translations[language.id] !== undefined"
                        >
                            <input type="text" v-model="translations[language.id].expiry" />
                            <div class="mt10" style="margin-top: 10px;">
                                <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.expiry" @click="deeplTranslate('expiry', translations[language.id].expiry)">
                                    <span v-if="!translating.expiry">Traduci con AI</span>
                                    <span v-else>
                                        <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TYPE -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Tipologia</strong></div>
                    <input type="text" v-model="library.type" />
                </div>

                <!-- OFFICIAL LINK -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Link Ufficiale</strong></div>
                    <input type="text" v-model="library.official_link" />
                </div>

                <!-- SCOPO MULTILINGUA -->
                <div class="form_inline">
                    <div class="w-25 mr-2"><strong class="label-form">Scopo</strong></div>

                    <div class="translations">
                        <!-- LINGUE -->
                        <ul class="change-languages">
                            <li
                                v-for="language in languages"
                                :key="language.id"
                                @click="languageSelect(language.slug)"
                                :class="{ selected: languageSelected === language.slug }"
                            >
                                <span :class="[flagClass(language.slug), 'flag-icon']"></span>
                            </li>
                        </ul>

                        <!-- EDITOR -->
                        <div
                            v-for="language in languages"
                            :key="language.id"
                            v-if="languageSelected === language.slug &&
                                   translations[language.id] !== undefined"
                        >
                            <editor
                                api-key="w9zd7syofrqk6xb3z20cjcd44pj5ryu4jdeg3ecrv568gjdl"
                                :init="{
                                    plugins: ['lists link image paste help wordcount code'],
                                    toolbar:
                                        'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link code'
                                }"
                                v-model="translations[language.id].scope"
                            />
                            <div class="mt10" style="margin-top: 10px;">
                                <button style="padding: 10px;cursor: pointer;" class="btn btn_small ml10" :disabled="translating.scope"@click="deeplTranslate('scope', translations[language.id].scope)">
                                    <span v-if="!translating.scope">Traduci con AI</span>
                                    <span v-else>
                                        <i class="fal fa-spinner fa-spin"></i> Traduzione...
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ACTION BAR -->
                <div class="bcm_action" style="display: flex; justify-content: space-between;">
                    <div v-if="openType !== 'modal'">
                        <div><strong>Created:</strong> {{ library.requestLogCreate }}</div>
                        <div><strong>Updated:</strong> {{ library.requestLogUpade }}</div>
                    </div>

                    <input type="button" :value="btn" @click="saveLibrary()" />
                </div>

            </div>
        </div>

    </section>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import langMap from '../../../assets/twocharlanguage.json';
import flagMixin from '../../../mixins/flagMixin';

export default {
    mixins: [flagMixin],
    name: "LibraryForm",

    props: {
        action: String,
        fromScanName: String,
        openType: { type: String, default: "inline" }
    },

    components: {
        editor: Editor
    },

    data() {
        return {
            title: "Library",
            translating: {
                expiry: false,
                scope: false
            }
        };
    },

    computed: {
        ...mapGetters({
            library: "librariesModule/library",
            scriptTypes: "librariesModule/scriptTypes",
            languages: "librariesModule/languages",
            translations: "librariesModule/translations",
            languageSelected: "librariesModule/languageSelected",
            hasPermission: "hasPermission"
        }),

        /** Padding dinamico */
        sectionClasses() {
            return {
                table: true,
                pb70: this.openType !== "modal",
                "full-section": this.openType === "modal"
            };
        },

        /** Title dinamico */
        btn() {
            let act = this.action || this.$route.params.action;
            return act === "create" ? "Salva" : "Modifica";
        }
    },

    methods: {
        loadLibrary() {
            this.$store.dispatch("librariesModule/loadLibrary", {
                urlToConnect: "libraries/" + this.$route.params.id + "/edit",
                id: this.$route.params.id
            });
        },

        createLibrary() {
            this.$store.dispatch("librariesModule/createLibrary", {
                urlToConnect: "libraries/create"
            });

            this.library.type_id = 1;
            this.library.requestLogCreate = "/";
            this.library.requestLogUpade = "/";
        },

        languageSelect(slug) {
            this.$store.dispatch("librariesModule/languageSelect", { slug });
        },

        saveLibrary() {
            let params = {
                urlToConnect: "libraries",
                methodToConnect: "post",
                library: this.library.library,
                type_id: this.library.type_id,
                name: this.library.name,
                supplier: this.library.supplier,
                expiry: this.library.expiry,
                type: this.library.type,
                official_link: this.library.official_link,
                translations: this.translations,
                scanID: this.library.scanID
            };

            let act = this.action || this.$route.params.action;

            if (act === "edit") {
                params.urlToConnect = "libraries/" + this.$route.params.id;
                params._method = "patch";
            }

            params.openType = this.openType;

            this.$store
                .dispatch("librariesModule/saveLibrary", params)
                .then((data) => {

                    if (this.openType === "modal") {
                        this.$emit("saved", data);
                        return;
                    }

                    if (act === "create") {
                        if (this.hasPermission("Libraries", "edit")) {
                            this.$router.replace("/libraries/" + data.id + "/edit");
                        } else {
                            this.$router.replace("/libraries");
                        }
                    }
                });
        },

        async deeplTranslate(field, textToTranslate) {
            if (this.translating[field]) return;

            this.$set(this.translating, field, true);

            const selectedLang = this.languageSelected;
            const languageObj = this.languages.find(l => l.slug === selectedLang);
            const sourceLang = langMap[languageObj.slug.toLowerCase()];

            const targetLangs = this.languages
                .filter(l => {
                    const iso2 = langMap[l.slug.toLowerCase()];
                    return iso2 && iso2 !== sourceLang;
                })
                .map(l => langMap[l.slug.toLowerCase()]);

            if (!textToTranslate || !targetLangs.length) {
                this.translating[field] = false;
                return;
            }

            const { text, tokens } = this.prepareForTranslation(textToTranslate);

            try {
                const payload = {
                    Text: [text],
                    SourceLang: sourceLang,
                    TargetLanguages: targetLangs,
                    Context: 'cookie description'
                };

                const response = await axios.post('/deepl-translate', payload);
                const data = response.data;

                if (!data.IsSucceded) {
                    throw new Error(data.Errors || 'Errore traduzione');
                }

                data.Data.forEach(translation => {
                    const langCode = translation.Translations[0].TargetLanguage;
                    const translatedRaw = translation.Translations[0].Text;

                    const langObj = this.languages.find(l => {
                        if (!l.slug) return false;
                        const iso2 = langMap[l.slug.toLowerCase()];
                        return iso2 && iso2 === langCode;
                    });

                    if (!langObj) return;

                    if (!this.translations[langObj.id]) {
                        this.$set(this.translations, langObj.id, {});
                    }

                    const finalText = this.restoreAfterTranslation(translatedRaw, tokens);

                    this.$set(this.translations[langObj.id], field, finalText);
                });

                // this.saveLibrary();

            } catch (err) {
                console.error('Errore durante la traduzione:', err);
            } finally {
                this.$set(this.translating, field, false);
            }
        },

        prepareForTranslation(html) {
            if (!html) return { text: '', tokens: [] };

            const tokens = [];
            let index = 0;

            const tokenize = match => {
                const key = `[${index}]`;
                tokens.push({ key, value: match });
                index++;
                return key;
            };

            // 🔒 Protegge i placeholder tipo |*LISTA DOMINI*| affinché DeepL non li traduca/alteri
            let text = html.replace(/\|\*.*?\*\|/g, tokenize);

            text = text.replace(/<[^>]+>/g, match => {
                if (/^<br\s*\/?>$/i.test(match)) {
                    return match;
                }

                return tokenize(match);
            });

            return { text, tokens };
        },

        restoreAfterTranslation(translatedText, tokens) {
            let result = translatedText;

            tokens.forEach(t => {
                result = result.replaceAll(t.key, t.value);
            });

            // normalizza BR duplicati
            result = result.replace(/(<br\s*\/?>\s*){2,}/gi, '<br />');

            return result;
        }
    },

    created() {
        const act = this.action || this.$route.params.action;

        if (act === "edit") {
            this.loadLibrary();
        } else {
            this.createLibrary();
            this.library.library = this.fromScanName;
            this.library.name = this.fromScanName;
        }
    },

};

</script>

<style scoped>
.no-padding-modal {
    padding: 0 !important;
}
</style>
